<template>
  <div v-if="hasAny" class="px-2 py-2 text-gray-700">
    <ul class="flex space-x-2">
      <li v-if="hasContent" class="relative">
        <span class="inline-block text-gray-800 rounded-full leading-none">
          <svg
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            stroke="currentColor"
            viewBox="0 0 24 24"
            class="w-4 h-4 inline-flex"
            v-tip="{ content: 'Requirements' }"
          >
            <path d="M4 6h16M4 12h16M4 18h7" />
          </svg>
        </span>
      </li>
      <li v-if="hasLinks" class="relative">
        <span class="inline-block text-gray-800 rounded-full leading-none">
          <svg
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            stroke="currentColor"
            viewBox="0 0 24 24"
            class="w-4 h-4 inline-flex"
            v-tip="{ content: 'Links' }"
          >
            <path
              d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656
                  5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4
                  4 0 00-5.656-5.656l-1.1 1.1"
            />
          </svg>
        </span>
      </li>
      <li v-if="hasMedia" class="relative">
        <span class="inline-block text-gray-800 rounded-full leading-none">
          <svg
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            stroke="currentColor"
            viewBox="0 0 24 24"
            class="w-4 h-4 inline-flex"
            v-tip="{ content: 'Attachments' }"
          >
            <path
              d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4
                  4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"
            />
          </svg>
        </span>
      </li>
      <li v-if="hasNotes" class="relative">
        <span class="inline-block text-gray-800 rounded-full leading-none">
          <svg
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            stroke="currentColor"
            viewBox="0 0 24 24"
            class="w-4 h-4 inline-flex"
            v-tip="{ content: 'Notes' }"
          >
            <path
              d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1
                  1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
            />
          </svg>
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'KanbanBoardTaskListLineMeta',
  props: {
    task: {
      type: Object,
      required: true,
    },
  },
  computed: {
    hasAny() {
      return this.hasContent || this.hasLinks || this.hasMedia || this.hasNotes;
    },
    hasContent() {
      return Boolean(this.task.content);
    },
    hasLinks() {
      return Boolean(this.task.linksCount);
    },
    hasMedia() {
      return Boolean(this.task.mediaCount);
    },
    hasNotes() {
      return Boolean(this.task.notesCount);
    },
  },
};
</script>
